import { i18n } from 'i18n';

const es = 'es';
const de = 'de';
const fr = 'fr';
const zh = 'zh';

enum LangPrefix {
  es = '_ES',
  de = '_DE',
  fr = '_FR',
  zh = '_ZH-HANS',
}

const buildUrl = (lang: string = ''): string =>
  `https://cdn.nonprod.3d4medical.com/media/complete-anatomy-3/screens${lang}.mp4`;

export const buildLocalizedVideoUrl = (): string => {
  const { language } = i18n;

  switch (language) {
    case fr:
      return buildUrl(LangPrefix.fr);

    case de:
      return buildUrl(LangPrefix.de);

    case es:
      return buildUrl(LangPrefix.es);

    case zh:
      return buildUrl(LangPrefix.zh);

    default:
      return buildUrl();
  }
};
